module.exports = __webpack_public_path__ + "static/media/map-marker-division-active.f7fa0565.svg";